import React, { FC } from 'react';
import { Col, Row } from 'react-bootstrap';

interface QuantityPickerProps {
    quantity: number;
    label: string;
    minusClickHandler?: () => void;
    plusClickHandler?: () => void;
    onChangeHandler?: (e: any) => void;
};

const QuantityPicker: FC<QuantityPickerProps> = ({ quantity, label, minusClickHandler, plusClickHandler, onChangeHandler }) => {
    const containerStyle = {
        width: 100,
        border: "1px solid #00a8e1",
        borderRadius: "17px",
        backgroundColor: "#fff",
        height: "35px",
        boxShadow: "0 3px 5px 0 rgb(0 0 0 / 18%)"
    }, panelStyle = {
        display: "flex",
        alignItems: "center"
    }, qtyInputStyle = {
        outline: "none",
        width: "50px",
        border: "none",
        textAlign: "center" as any
    }, minusBtnStyle = {
        marginLeft: "3px",
        cursor: "pointer"
    }, plusBtnStyle = {
        cursor: "pointer"
    };

    return <Row style={containerStyle}>
        <Col style={panelStyle}>
            <div style={minusBtnStyle} className="my-auto" onClick={minusClickHandler}>–</div>
            <div className="p-0">
                <input type="number" pattern="[0-9]+" min="0" max="99" style={qtyInputStyle} value={quantity} onChange={onChangeHandler} aria-label={label} />
            </div>
            <div style={plusBtnStyle} className="my-auto" onClick={plusClickHandler}>+</div>
        </Col>
    </Row>;
}

export default QuantityPicker;